
import * as echarts from "echarts";

/** ======[常用颜色配置项]================================================================================ */


/** ------------ [色值：默认配置项] ------------ */
/** 色值列表：默认 */
export const defaultColorList = [
  '#1862F5',/* primary */
  '#FEC760',/* warning */
  '#52C41A',/* success */
  '#13A8A8',/* cyan */
  '#722ED1',/* purple */
  '#EB2F96',/* magenta */
  '#FA8C16',/* orange */
  '#FADB14',/* yellow */
  '#A0D911',/* lime */
  '#52C41A',/* green */
]

/**
 * 获取：默认的颜色列表
 * @returns 
 */
export function getDefaultColorList() {
  return defaultColorList;
}



/** ------------ [色值：eCharts] ------------ */
/**
 * 获取：折线图-默认颜色配置项
 * @returns 
 */
export function getLineChartDefaultColors() {
  const options = {
    defaultColorList: defaultColorList,
    textColor: "#8b93aa", // 图表文字的颜色
    axisColor: "#3e4961", // 坐标轴的【刻度线】【分割线】等的颜色
  }

  return options;
}









/** ------------ [色值：时段电价] ------------ */
/**
 * 获取：时段电价-颜色配置项
 * @param {*} key 可选，不传时-返回colors对象，传时段名称时，返回对应时段的色值
 * 以sharp为例：'sharp', 'inSharp', 'outSharp', 'inSharpPrice', 'outSharpPrice' 在字典中获取到的颜色值，均为 '#F1314C'
 * @returns 
 */
export function getElecPriceSegmentColor(key) {
  const colors = {
    sharp: '#FA3636', // 尖
    peak: '#FA711E', // 峰
    flat: '#14D872', // 平
    valley: '#1283F0', // 谷
    deepValley: '#EFC700', // 深
  } 
  const segmentList = Object.keys(colors);

  const keyMap = new Map();
  const prefixArr = ['', 'in', 'out'];
  const suffixArr = ['', 'Price'];

  segmentList.forEach(it => {
    prefixArr.forEach(pre => {
      let baseKey = it;
      if (pre) {
        baseKey = it.charAt(0).toUpperCase() + it.slice(1);
      }
      suffixArr.forEach(fix => {
        const mapKey = pre + baseKey + fix;
        keyMap.set(mapKey, colors[it]);
      })
    })
  })

  if (key) {
    if (keyMap.has(key)) {
      return keyMap.get(key);
    } else {
      console.error(`没有 ${key} 对应时段的颜色值！`);
      return '';
    }
  } else {
    return colors;
  }

}






/** ======[辅助功能方法]================================================================================ */
/**
 * 给颜色设置透明度
 * @param {*} color 
 * @param {*} alpha 
 * @returns 
 */
export function setColorAlpha(color, alpha) {
  if (isNaN(Number(alpha))) {
    console.error('setAlpha需要传入正确的颜色值和透明度值，请检查！',color, alpha);
    return color;
  }
  return echarts.color.modifyAlpha(color, alpha);
}




